export const accountingCards = {
    accountingPeriodCard: {
        entity: 'accountingPeriod',
        path: 'accountingPeriod',
        titleBar: { mergeParams: ['name'], new: 'accountingPeriod.form.new.title' },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    type: 'submit',
                    id: 'accountingPeriodCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'close',
                    actionType: 'post',
                    label: 'accountingPeriod.form.close',
                    confirm: true,
                    modalConfig: 'accountingPeriodConfirmClose',
                    dependency: { id: 'state', value: 'open' }
                },
                {
                    action: 'reopen',
                    actionType: 'post',
                    label: 'accountingPeriod.form.reopen',
                    confirm: true,
                    modalConfig: 'accountingPeriodConfirmReopen',
                    dependency: { id: 'state', value: 'closed' }
                },
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'accountingPeriodConfirmDelete'
                }
            ],
            actions: {
                close: { message: 'accountingPeriod.action.close.message', reload: true },
                reopen: { message: 'accountingPeriod.action.reopen.message', reload: true }
            }
        },
        width: '700px',
        sections: [
            {
                id: 'accountingPeriod',
                meta: {
                    type: 'form',
                    width: '700px'
                },
                groups: [
                    {
                        type: 'text',
                        id: 'name',
                        label: 'accountingPeriod.form.name',
                        placeholder: 'accountingPeriod.form.name.placeholder',
                        required: true
                    },
                    {
                        type: 'group',
                        id: 'fromTo',
                        fields: [
                            {
                                type: 'date',
                                id: 'fromDate',
                                label: 'accountingPeriod.form.fromDate',
                                required: true,
                                defaultType: 'date'
                            },
                            {
                                type: 'date',
                                id: 'toDate',
                                label: 'accountingPeriod.form.toDate',
                                required: true,
                                defaultType: 'date'
                            }
                        ]
                    },
                    {
                        type: 'text-readOnly',
                        id: 'stateName',
                        label: 'accountingPeriod.form.state'
                    },
                    {
                        type: 'textarea',
                        id: 'note',
                        label: 'accountingPeriod.form.note',
                        placeholder: 'accountingPeriod.form.note.placeholder',
                        rows: 3
                    },
                    {
                        type: 'description',
                        id: 'help',
                        label: 'accountingPeriod.form.help.label',
                        text: 'accountingPeriod.form.help.text'
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'accountingPeriodCard.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} — ${2}',
                                    mergeParams: ['fromDate', 'toDate'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },
    accountingSettingsCard: {
        entity: 'accountingSettings',
        path: 'accountingSettings',
        titleBar: { label: 'accountingSettings.title', new: 'accountingSettings.title' },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    type: 'submit',
                    id: 'accountingSettingsCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ]
        },
        width: '756px',
        afterSubmit: { stay: true },
        sections: [
            {
                id: 'accountingSettings.vatProfile',
                meta: {
                    type: 'form',
                    width: '756px'
                },
                groups: [
                    {
                        type: 'description',
                        id: 'vatProfileIntro',
                        label: 'accounting.settings.vatProfile.title',
                        text: 'accounting.settings.vatProfile.description'
                    },
                    {
                        type: 'separator',
                        id: 'vatProfileSeparator'
                    },
                    {
                        type: 'select',
                        id: 'vatProfile',
                        displayField: 'vatProfileName',
                        label: 'accounting.settings.vatProfile',
                        placeholder: 'accounting.settings.vatProfile.placeholder',
                        entity: 'vatProfile',
                        valueMap: {
                            'vatProfile': 'id',
                            'vatProfileName': 'name'
                        },
                        options: { withHeaders: false },
                        required: true,
                        defaultType: 'value',
                        defaultValue: 'standard'
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'accountingSettingsCard.vatProfile.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'vatProfile',
                    emptyMessage: 'accounting.settings.vatProfile.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'accounting.settings.vatProfile.title',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'vatProfileName',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            /*
             * The EU One Stop Shop. Registered, a sale to a private customer in
             * another EU country carries that country's VAT (OSSVatRates.json)
             * from the effective date on, and is reported in the quarterly OSS
             * return. Not registered — below EUR 10,000 a year of such sales —
             * the org's own VAT applies. GET vatTax reads both fields.
             */
            {
                id: 'accountingSettings.oss',
                meta: {
                    type: 'form',
                    width: '756px',
                    onMount: 'collapse'
                },
                groups: [
                    {
                        type: 'description',
                        id: 'ossIntro',
                        label: 'accounting.settings.oss.title',
                        text: 'accounting.settings.oss.description'
                    },
                    {
                        type: 'separator',
                        id: 'ossSeparator'
                    },
                    {
                        type: 'group',
                        id: 'ossRegisteredEffectiveDate',
                        fields: [
                            {
                                type: 'switch',
                                id: 'ossRegistered',
                                label: 'accounting.settings.ossRegistered',
                                defaultType: 'value',
                                defaultValue: false
                            },
                            {
                                type: 'date',
                                id: 'ossEffectiveDate',
                                label: 'accounting.settings.ossEffectiveDate',
                                placeholder: 'accounting.settings.ossEffectiveDate.placeholder',
                                condition: { field: 'ossRegistered', operator: 'equals', value: true }
                            }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'accountingSettingsCard.oss.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    // Not registered is a setting, not missing information: the
                    // summary says so, with the edit icon. vatProfile is always
                    // there once the settings exist, as for the section below.
                    emptyField: 'vatProfile',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                { type: 'text', value: 'accounting.settings.oss.title', scale: 'title' },
                                { type: 'date', value: 'ossEffectiveDate', prefix: 'accounting.settings.oss.registeredFrom', scale: 'normal', condition: { field: 'ossRegistered', operator: 'equals', value: true } },
                                { type: 'text', value: 'accounting.settings.oss.notRegistered', scale: 'normal', condition: { field: 'ossRegistered', operator: 'notEquals', value: true } }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'accountingSettings.vatDeduction',
                meta: {
                    type: 'form',
                    width: '756px',
                    onMount: 'collapse'
                },
                groups: [
                    {
                        type: 'description',
                        id: 'vatDeductionIntro',
                        label: 'accounting.settings.vatDeduction.title',
                        text: 'accounting.settings.vatDeduction.description'
                    },
                    {
                        type: 'separator',
                        id: 'vatDeductionSeparator'
                    },
                    {
                        type: 'group',
                        id: 'vatEstimatePartial',
                        fields: [
                            {
                                type: 'number',
                                id: 'vatEstimatePct',
                                label: 'accounting.settings.vatEstimatePct',
                                placeholder: 'accounting.settings.pct.placeholder',
                                decimals: 2
                            },
                            {
                                type: 'number',
                                id: 'vatPartialPct',
                                label: 'accounting.settings.vatPartialPct',
                                placeholder: 'accounting.settings.pct.placeholder',
                                decimals: 2
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'vatSectorArea',
                        fields: [
                            {
                                type: 'number',
                                id: 'vatSectorPct',
                                label: 'accounting.settings.vatSectorPct',
                                placeholder: 'accounting.settings.pct.placeholder',
                                decimals: 2
                            },
                            {
                                type: 'number',
                                id: 'vatAreaPct',
                                label: 'accounting.settings.vatAreaPct',
                                placeholder: 'accounting.settings.pct.placeholder',
                                decimals: 2
                            }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'accountingSettingsCard.vatDeduction.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'vatProfile',
                    emptyMessage: 'accounting.settings.vatDeduction.title',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'accounting.settings.vatDeduction.title',
                                    scale: 'title'
                                },
                                {
                                    type: 'text',
                                    value: 'accounting.settings.vatDeduction.description',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            /*
             * The same figures per year. A pro rata share is provisional until
             * the year's actual turnover split is known, so each year needs its
             * own; posting takes the row for the year of its accounting date and
             * falls back to the undated figures above.
             */
            {
                id: 'accountingSettings.vatDeductionYears',
                meta: {
                    type: 'lines',
                    linesArray: 'vatDeductionYears',
                    linesAddAction: 'accounting.settings.vatDeductionYears.add',
                    sectionTitle: 'accounting.settings.vatDeductionYears.title',
                    width: '756px'
                },
                groups: [
                    {
                        type: 'number',
                        id: 'year',
                        label: 'accounting.settings.vatDeductionYears.year',
                        placeholder: 'accounting.settings.vatDeductionYears.year.placeholder',
                        required: true,
                        decimals: 0
                    },
                    {
                        type: 'group',
                        id: 'yearEstimatePartial',
                        fields: [
                            {
                                type: 'number',
                                id: 'vatEstimatePct',
                                label: 'accounting.settings.vatEstimatePct',
                                placeholder: 'accounting.settings.pct.placeholder',
                                decimals: 2
                            },
                            {
                                type: 'number',
                                id: 'vatPartialPct',
                                label: 'accounting.settings.vatPartialPct',
                                placeholder: 'accounting.settings.pct.placeholder',
                                decimals: 2
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'yearSectorArea',
                        fields: [
                            {
                                type: 'number',
                                id: 'vatSectorPct',
                                label: 'accounting.settings.vatSectorPct',
                                placeholder: 'accounting.settings.pct.placeholder',
                                decimals: 2
                            },
                            {
                                type: 'number',
                                id: 'vatAreaPct',
                                label: 'accounting.settings.vatAreaPct',
                                placeholder: 'accounting.settings.pct.placeholder',
                                decimals: 2
                            }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'accountingSettingsCard.vatDeductionYears.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'accountingSettingsCard.vatDeductionYears.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'year',
                    emptyMessage: 'accounting.settings.vatDeductionYears.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'year',
                                    scale: 'title'
                                },
                                {
                                    type: 'merge',
                                    value: 'accounting.settings.vatDeductionYears.summary',
                                    mergeParams: ['vatPartialPct', 'vatEstimatePct', 'vatSectorPct', 'vatAreaPct'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            // The module's number series (37.03) — see salesSettingsCard. Here
            // the journal series, which numbers every journal as it is posted.
            {
                id: 'accountingSettings.numberSeries',
                meta: {
                    type: 'lines',
                    linesArray: 'numberSeries',
                    showAddLine: false,
                    sectionTitle: 'settings.numberSeries.title',
                    width: '756px'
                },
                groups: [
                    { type: 'text-readOnly', id: 'format', label: 'settings.numberSeries.format' },
                    { type: 'text-readOnly', id: 'lastValue', label: 'settings.numberSeries.lastValue' },
                    { type: 'nserie', id: 'nextValue', label: 'settings.numberSeries.nextValue', placeholder: 'settings.numberSeries.nextValue.placeholder', required: true }
                ],
                buttons: [
                    { type: 'submit', id: 'accountingSettingsCard.numberSeries.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'nextValue',
                    emptyMessage: 'settings.numberSeries.empty',
                    columns: [
                        {
                            weight: 6, basis: '60%',
                            elements: [
                                { type: 'merge', value: '${1}', mergeParams: [{ type: 'translate', value: 'labelKey' }], scale: 'title' },
                                { type: 'field', value: 'format', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 4, basis: '40%', align: 'end',
                            elements: [
                                { type: 'field', value: 'nextValue', scale: 'title', prefix: 'settings.numberSeries.next.prefix' },
                                { type: 'field', value: 'lastValue', scale: 'normal', prefix: 'settings.numberSeries.last.prefix', condition: { field: 'lastValue', operator: 'notEmpty' } }
                            ]
                        }
                    ]
                }
            }
        ]
    },
    /*
     * The journal for entering many lines quickly: the same record as
     * journalCard, but the lines are a grid (journalLinesGrid) — one row per
     * line, Tab from cell to cell, Tab past the last cell starts a new row.
     * What the grid cannot show per row (the party, the document, a deductible
     * share) stays in journalCard; a journal can be opened in either.
     *
     * A new journal reopens here once saved, so entry carries on in the grid.
     */
    fastJournalCard: {
        entity: 'journal',
        path: 'journal',
        titleBar: { mergeParams: ['description'], new: 'journal.fast.form.new.title' },
        cardTitle: {
            title: 'journal.form.dropdown.toggle',
            buttons: [
                {
                    type: 'submit',
                    id: 'fastJournalCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'journalConfirmDelete'
                },
                {
                    action: 'post',
                    label: 'journal.form.menu.post',
                    actionType: 'post',
                    confirm: true,
                    modalConfig: 'journalConfirmPost'
                }
            ],
            actions: {
                post: { message: 'journal.action.post.message', reload: true }
            }
        },
        width: '1600px',
        afterSubmit: { navigateTo: '/accounting/fast-journal' },
        defaultData: [
            {
                id: 'bookId',
                defaultType: 'value',
                defaultValue: 'BASE'
            }
        ],
        sections: [
            {
                id: 'fastJournal.header',
                meta: {
                    type: 'form',
                    width: '1600px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'accountingDateDescriptionCurrency',
                        fields: [
                            {
                                type: 'date',
                                id: 'accountingDate',
                                label: 'journal.form.accountingDate',
                                placeholder: 'journal.form.accountingDate.placeholder',
                                required: true,
                                defaultType: 'date',
                                weight: 2
                            },
                            {
                                type: 'text',
                                id: 'description',
                                label: 'journal.form.description',
                                placeholder: 'journal.form.description.placeholder',
                                required: true,
                                weight: 5
                            },
                            {
                                // Shown as its code alone (DKK): the field is
                                // narrow, and a code is what a bookkeeper reads.
                                type: 'currency',
                                id: 'baseCurrency',
                                displayField: 'baseCurrency',
                                label: 'journal.form.currency',
                                entity: 'currency',
                                valueMap: {
                                    'baseCurrency': 'id',
                                    'baseCurrencyName': 'name',
                                    'transactionCurrency': 'id'
                                },
                                options: { withHeaders: false, displayId: true },
                                required: true,
                                linkedFields: ['lines'],
                                weight: 1
                            },
                            {
                                type: 'text-readOnly',
                                id: 'totalDebitBase',
                                label: 'journal.form.totalDebit',
                                highlight: {
                                    condition: { field: 'totalDebitBase', operator: 'lt', valueFrom: 'values.totalCreditBase' }
                                },
                                displayType: 'amount',
                                weight: 2
                            },
                            {
                                type: 'text-readOnly',
                                id: 'totalCreditBase',
                                label: 'journal.form.totalCredit',
                                highlight: {
                                    condition: { field: 'totalCreditBase', operator: 'lt', valueFrom: 'values.totalDebitBase' }
                                },
                                displayType: 'amount',
                                weight: 2
                            }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'fastJournalCard.header.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'description',
                    emptyMessage: 'journal.form.description.missing.message',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'title'
                                },
                                {
                                    type: 'date',
                                    value: 'accountingDate',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'totalDebitBase',
                                    scale: 'title',
                                    decorator: 'baseCurrency',
                                    displayType: 'amount'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'fastJournal.lines',
                // Room for the type and account lists to open on the last row.
                meta: { type: 'grid', gridConfig: 'journalLinesGrid', marginBottom: '20rem' }
            }
        ]
    },
    glAccountCard: {
        entity: 'glAccount',
        path: 'glAccount',
        titleBar: { mergeParams: ['name'], new: 'glAccount.form.new.title' },
        cardTitle: {
            title: 'glAccount.form.dropdown.toggle',
            buttons: [
                {
                    type: 'submit',
                    id: 'glAccountCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'glAccountConfirmDelete'
                }
            ]
        },
        width: '700px',
        sections: [
            {
                id: 'glAccount',
                meta: {
                    type: 'form',
                    width: '700px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'numberName',
                        fields: [
                            {
                                type: 'text',
                                id: 'number',
                                label: 'glAccount.form.number',
                                placeholder: 'glAccount.form.number.placeholder',
                                required: true
                            },
                            {
                                type: 'text',
                                id: 'name',
                                label: 'glAccount.form.name',
                                placeholder: 'glAccount.form.name.placeholder',
                                required: true
                            }
                        ]
                    },
                    {
                        type: 'text',
                        id: 'nameEn',
                        label: 'glAccount.form.nameEn',
                        placeholder: 'glAccount.form.nameEn.placeholder'
                    },
                    {
                        type: 'group',
                        id: 'accountTypeCategory',
                        fields: [
                            {
                                type: 'select',
                                id: 'accountType',
                                displayField: 'accountTypeName',
                                label: 'glAccount.form.accountType',
                                entity: 'glAccountType',
                                valueMap: {
                                    'accountType': 'id',
                                    'accountTypeName': 'name'
                                },
                                options: { withHeaders: false },
                                defaultType: 'value',
                                defaultValue: 'posting'
                            },
                            {
                                type: 'select',
                                id: 'category',
                                displayField: 'categoryName',
                                label: 'glAccount.form.category',
                                placeholder: 'glAccount.form.category.placeholder',
                                entity: 'glAccountCategory',
                                valueMap: {
                                    'category': 'id',
                                    'categoryName': 'name'
                                },
                                options: { withHeaders: false }
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'normalBalanceTag',
                        fields: [
                            {
                                type: 'select',
                                id: 'normalBalance',
                                displayField: 'normalBalanceName',
                                label: 'glAccount.form.normalBalance',
                                placeholder: 'glAccount.form.normalBalance.placeholder',
                                entity: 'glNormalBalance',
                                valueMap: {
                                    'normalBalance': 'id',
                                    'normalBalanceName': 'name'
                                },
                                options: { withHeaders: false }
                            },
                            {
                                type: 'text',
                                id: 'tag',
                                label: 'glAccount.form.tag',
                                placeholder: 'glAccount.form.tag.placeholder'
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'isPostableActive',
                        fields: [
                            {
                                type: 'switch',
                                id: 'isPostable',
                                label: 'glAccount.form.isPostable',
                                defaultType: 'value',
                                defaultValue: true
                            },
                            {
                                type: 'switch',
                                id: 'active',
                                label: 'glAccount.form.active',
                                defaultType: 'value',
                                defaultValue: true
                            }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'glAccountCard.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    emptyMessage: 'glAccount.form.name.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} — ${2}',
                                    mergeParams: ['number', 'name'],
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'categoryName',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },
    journalCard: {
        entity: 'journal',
        path: 'journal',
        titleBar: { mergeParams: ['description'], new: 'journal.form.new.title' },
        cardTitle: {
            title: 'journal.form.dropdown.toggle',
            buttons: [
                {
                    type: 'submit',
                    id: 'journalCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'journalConfirmDelete'
                },
                {
                    action: 'post',
                    label: 'journal.form.menu.post',
                    actionType: 'post',
                    confirm: true,
                    modalConfig: 'journalConfirmPost'
                }
            ],
            actions: {
                post: { message: 'journal.action.post.message', reload: true }
            }
        },
        width: '1024px',
        defaultData: [
            {
                id: 'bookId',
                defaultType: 'value',
                defaultValue: 'BASE'
            }
        ],
        sections: [
            {
                id: 'journal.header',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'accountingDateBookId',
                        fields: [
                            {
                                type: 'date',
                                id: 'accountingDate',
                                label: 'journal.form.accountingDate',
                                placeholder: 'journal.form.accountingDate.placeholder',
                                required: true,
                                defaultType: 'date'
                            },
                            {
                                type: 'text-readOnly',
                                id: 'bookId',
                                label: 'journal.form.book'
                            },
                            {
                                type: 'currency',
                                id: 'baseCurrency',
                                displayField: 'baseCurrencyName',
                                label: 'journal.form.currency',
                                entity: 'currency',
                                valueMap: {
                                    'baseCurrency': 'id',
                                    'baseCurrencyName': 'name',
                                    'transactionCurrency': 'id'
                                },
                                options: { withHeaders: false, displayId: true },
                                required: true,
                                // Only 'lines' is read here — the connect's own
                                // returnData already carries baseCurrency/
                                // transactionCurrency into fieldsLogicData's
                                // sub.setFromRoot broadcast onto every line.
                                linkedFields: ['lines']
                            }
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'description',
                        label: 'journal.form.description',
                        placeholder: 'journal.form.description.placeholder',
                        required: true,
                        rows: 2
                    },
                    {
                        type: 'group',
                        id: 'totalDebitBaseTotalCreditBase',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'totalDebitBase',
                                label: 'journal.form.totalDebit',
                                // Red whenever debit is short of credit — a
                                // balanced journal never posts otherwise, so
                                // this flags an in-progress imbalance early.
                                highlight: {
                                    condition: { field: 'totalDebitBase', operator: 'lt', valueFrom: 'values.totalCreditBase' }
                                },
                                displayType: 'amount'
                            },
                            {
                                type: 'text-readOnly',
                                id: 'totalCreditBase',
                                label: 'journal.form.totalCredit',
                                highlight: {
                                    condition: { field: 'totalCreditBase', operator: 'lt', valueFrom: 'values.totalDebitBase' }
                                },
                                displayType: 'amount'
                            }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'journalCard.header.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'description',
                    emptyMessage: 'journal.form.description.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'title'
                                },
                                {
                                    type: 'date',
                                    value: 'accountingDate',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'journal.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'journal.form.line.add',
                    // Each line's documents: a button on the line, the side
                    // panel on desktop, a modal on mobile (lineDocumentsData).
                    lineDocuments: 'journalLine',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'typeAccountAmount',
                        fields: [
                            {
                                /*
                                 * Picked as a preset, not as the bare type: a
                                 * preset sets the type and the side its party is
                                 * on together, so "payment received" and "payment
                                 * made" are two choices while the line still
                                 * posts as PAYMENT. Each preset has a letter in
                                 * the org's language that picks it at once.
                                 *
                                 * A preset carries no party or document, so the
                                 * nullDefaults clear the line's: a customer picked
                                 * under "payment received" must not stay on the
                                 * line once it says "payment made".
                                 */
                                type: 'select',
                                id: 'linePreset',
                                displayField: 'typeName',
                                label: 'journal.form.line.type',
                                entity: 'journalLinePreset',
                                valueMap: {
                                    'linePreset': 'id',
                                    'type': 'type',
                                    'typeName': 'name',
                                    'typeRefType': 'typeRefType',
                                    'typeRefId': 'typeRefId',
                                    'typeRefIdName': 'typeRefIdName',
                                    'documentType': 'documentType',
                                    'documentId': 'documentId',
                                    'documentNumber': 'documentNumber'
                                },
                                nullDefaults: {
                                    typeRefType: null,
                                    typeRefId: null,
                                    typeRefIdName: '',
                                    documentType: null,
                                    documentId: null,
                                    documentNumber: null
                                },
                                options: { withHeaders: false },
                                defaultType: 'value',
                                defaultValue: 'FINANCIAL',
                                weight: 1
                            },
                            {
                                type: 'connect',
                                id: 'accountId',
                                displayField: 'accountIdName',
                                label: 'journal.form.line.account',
                                placeholder: 'journal.form.line.account.placeholder',
                                modalTitle: 'journal.form.line.account.modal.title',
                                entity: 'glAccount',
                                valueMap: {
                                    'accountId': 'id',
                                    'accountIdName': 'name',
                                    'accountNo': 'number',
                                    'accountNormalBalance': 'normalBalance',
                                    'accountCategory': 'category'
                                },
                                options: {
                                    withHeaders: false,
                                    highlight: { condition: { field: 'accountType', operator: 'in', value: ['header', 'sum'] } },
                                    selectable: { condition: { field: 'isPostable', operator: 'notEquals', value: false } }
                                },
                                listDisplay: { text: '${2} - ${1}', params: ['name', 'number'] },
                                required: true,
                                weight: 3
                            },
                            {
                                type: 'dualInput',
                                id: 'debitAmount',
                                secondaryId: 'creditAmount',
                                label: 'journal.form.line.amount',
                                placeholder: 'journal.form.line.amount.placeholder',
                                primaryLabel: 'journal.form.line.debit.short',
                                secondaryLabel: 'journal.form.line.credit.short',
                                decimals: 2,
                                defaultSide: {
                                    field: 'accountNormalBalance',
                                    secondaryWhen: 'credit'
                                },
                                lineLinkedFields: ['accountNormalBalance'],
                                variant: 'price',
                                weight: 2
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'descriptionCounterAccount',
                        fields: [
                            {
                                type: 'text',
                                id: 'description',
                                label: 'journal.form.line.description',
                                placeholder: 'journal.form.line.description.placeholder',
                                weight: 4
                            },
                            {
                                type: 'connect',
                                id: 'counterAccountId',
                                displayField: 'counterAccountIdName',
                                label: 'journal.form.line.counterAccount',
                                placeholder: 'journal.form.line.counterAccount.placeholder',
                                modalTitle: 'journal.form.line.counterAccount.modal.title',
                                entity: 'glAccount',
                                valueMap: {
                                    'counterAccountId': 'id',
                                    'counterAccountIdName': 'name',
                                    'counterAccountCategory': 'category'
                                },
                                options: {
                                    withHeaders: false,
                                    highlight: { condition: { field: 'accountType', operator: 'in', value: ['header', 'sum'] } },
                                    selectable: { condition: { field: 'isPostable', operator: 'notEquals', value: false } }
                                },
                                listDisplay: { text: '${1} - ${2}', params: ['name', 'number'] },
                                required: false,
                                weight: 2
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'vatPartyDocument',
                        // One row for what a line needs beyond its accounts: VAT
                        // when it touches income or expense, the party and its
                        // document when the preset is against someone. Empty for
                        // a plain line, so the row takes no space then.
                        condition: {
                            any: [
                                { field: 'accountCategory', operator: 'in', value: ['income', 'expense'] },
                                { field: 'counterAccountCategory', operator: 'in', value: ['income', 'expense'] },
                                { field: 'typeRefType', operator: 'in', value: ['customer', 'supplier'] }
                            ]
                        },
                        fields: [
                            {
                                type: 'select',
                                id: 'vatTaxId',
                                displayField: 'vatTaxIdName',
                                label: 'journal.form.line.vatTax',
                                placeholder: 'journal.form.line.vatTax.placeholder',
                                entity: 'vatTax',
                                valueMap: {
                                    'vatTaxId': 'id',
                                    'vatTaxIdName': 'name',
                                    'vatTaxJurisdiction': 'jurisdiction',
                                    // Only so the deductiblePct field below knows
                                    // whether to appear — see the note on it.
                                    'vatTaxDeductionMethod': 'deductionMethod'
                                },
                                options: { withHeaders: false },
                                entityParams: { type: 'query', params: [{ key: 'scope', value: 'sales' }] },
                                required: false,
                                // Whichever of the two accounts on this line is actually
                                // income/expense decides both whether VAT shows at all and
                                // which scope of codes it offers — never assumes which of
                                // account/counterAccount holds it (users differ on this).
                                condition: {
                                    any: [
                                        { field: 'accountCategory', operator: 'in', value: ['income', 'expense'] },
                                        { field: 'counterAccountCategory', operator: 'in', value: ['income', 'expense'] }
                                    ]
                                },
                                conditionals: [
                                    {
                                        condition: {
                                            any: [
                                                { field: 'accountCategory', operator: 'equals', value: 'expense' },
                                                { field: 'counterAccountCategory', operator: 'equals', value: 'expense' }
                                            ]
                                        },
                                        set: { entityParams: { type: 'query', params: [{ key: 'scope', value: 'purchases' }] } }
                                    }
                                ],
                                weight: 2
                            },
                            {
                                /*
                                 * Only four deduction methods need asking about.
                                 *
                                 * partial (a pro rata share), estimate (an
                                 * estimated business-use split) and area (a
                                 * floor-area split of a property) are properties
                                 * of the purchase, not of the code: two buildings
                                 * with different splits carry the same code. Every
                                 * other method is settled by the code itself —
                                 * full, none, and statutory figures like the 33.3
                                 * on a yellow-plate lease — so showing this for
                                 * them would invite an override that posting would
                                 * ignore.
                                 *
                                 * Left empty, posting uses the company's figure for
                                 * the method from Accounting Settings — so it is
                                 * optional, and only needed where this purchase
                                 * differs. With neither, posting refuses the line
                                 * rather than deducting in full: a silent full
                                 * deduction is a wrong number nobody chose. Sector
                                 * splits are asked about too now that there is a
                                 * company figure for them to default to.
                                 */
                                type: 'number',
                                id: 'deductiblePct',
                                label: 'journal.form.line.deductiblePct',
                                placeholder: 'journal.form.line.deductiblePct.placeholder',
                                min: 0,
                                max: 100,
                                condition: {
                                    field: 'vatTaxDeductionMethod',
                                    operator: 'in',
                                    value: ['partial', 'estimate', 'area', 'sector']
                                },
                                weight: 2
                            },
                            {
                                /*
                                 * The customer or supplier, by the preset's side.
                                 * A contact carries no document, so the
                                 * nullDefaults clear the line's when the party
                                 * changes — one customer's invoice must not stay
                                 * on a line now against another.
                                 */
                                type: 'connect',
                                id: 'typeRefId',
                                displayField: 'typeRefIdName',
                                label: 'journal.form.line.customer',
                                placeholder: 'journal.form.line.customer.placeholder',
                                modalTitle: 'journal.form.line.customer.modal.title',
                                entity: 'contact',
                                entityParams: { type: 'filter', filters: [{ key: 'contactType', value: 'customer|both|undefined' }] },
                                valueMap: {
                                    'typeRefId': 'id',
                                    'typeRefIdName': 'name',
                                    'documentType': 'documentType',
                                    'documentId': 'documentId',
                                    'documentNumber': 'documentNumber'
                                },
                                nullDefaults: {
                                    documentType: null,
                                    documentId: null,
                                    documentNumber: null
                                },
                                options: { withHeaders: false },
                                condition: { field: 'typeRefType', operator: 'in', value: ['customer', 'supplier'] },
                                conditionals: [
                                    {
                                        condition: { field: 'typeRefType', operator: 'equals', value: 'supplier' },
                                        set: {
                                            label: 'journal.form.line.vendor',
                                            placeholder: 'journal.form.line.vendor.placeholder',
                                            modalTitle: 'journal.form.line.vendor.modal.title',
                                            entityParams: { type: 'filter', filters: [{ key: 'contactType', value: 'supplier|both' }] }
                                        }
                                    }
                                ],
                                weight: 2
                            },
                            {
                                /*
                                 * The invoice or expense the line belongs to or
                                 * settles — booked and not yet paid, and the
                                 * party's own once one is picked. Picking the
                                 * document first fills in its party.
                                 *
                                 * A reference only: naming an invoice here does
                                 * not change what it still owes. Settling a
                                 * document is done on the document.
                                 */
                                type: 'connect',
                                id: 'documentId',
                                displayField: 'documentNumber',
                                label: 'journal.form.line.invoice',
                                placeholder: 'journal.form.line.invoice.placeholder',
                                modalTitle: 'journal.form.line.invoice.modal.title',
                                entity: 'invoice',
                                entityParams: {
                                    type: 'filter',
                                    filters: [
                                        { key: 'customerId', value: '${typeRefId}' },
                                        { key: 'state', value: 'final' },
                                        { key: 'paid', value: 'false|undefined' }
                                    ]
                                },
                                valueMap: {
                                    'documentId': 'id',
                                    'documentNumber': 'bookedNumber',
                                    'documentType': 'entity',
                                    'typeRefId': 'customerId',
                                    'typeRefIdName': 'customerName'
                                },
                                options: { withHeaders: false },
                                menuItemField: 'bookedNumber',
                                lineLinkedFields: ['typeRefId'],
                                condition: { field: 'typeRefType', operator: 'in', value: ['customer', 'supplier'] },
                                conditionals: [
                                    {
                                        condition: { field: 'typeRefType', operator: 'equals', value: 'supplier' },
                                        set: {
                                            label: 'journal.form.line.expense',
                                            placeholder: 'journal.form.line.expense.placeholder',
                                            modalTitle: 'journal.form.line.expense.modal.title',
                                            entity: 'expense',
                                            entityParams: {
                                                type: 'filter',
                                                filters: [
                                                    { key: 'supplierId', value: '${typeRefId}' },
                                                    { key: 'state', value: 'final' },
                                                    { key: 'paid', value: 'false|undefined' }
                                                ]
                                            },
                                            valueMap: {
                                                'documentId': 'id',
                                                'documentNumber': 'bookedNumber',
                                                'documentType': 'entity',
                                                'typeRefId': 'supplierId',
                                                'typeRefIdName': 'supplierName'
                                            }
                                        }
                                    }
                                ],
                                weight: 2
                            }
                        ]
                    },
                    // Outside the row above: inside a group a hidden field still
                    // takes a column. Kept only so the deductiblePct field knows
                    // whether to appear.
                    {
                        type: 'hidden',
                        id: 'vatTaxDeductionMethod'
                    },
                    // Mirrors the header's currency onto every line — there is no
                    // per-line currency picker, so a line's currency always tracks
                    // whatever the header is currently set to (same pattern as
                    // invoicePayments' paymentCurrency mirroring invoice.currency).
                    {
                        type: 'hidden',
                        id: 'baseCurrency',
                        statePath: 'baseCurrency'
                    },
                    {
                        type: 'hidden',
                        id: 'transactionCurrency',
                        statePath: 'transactionCurrency'
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'journalCard.lines.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'journalCard.lines.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'accountIdName',
                    emptyMessage: 'journal.form.line.account.missing.message',
                    // Three columns are too narrow on a phone: there the
                    // account, the line's type and party, and the counter
                    // account read one under the other.
                    stackOnMobile: true,
                    columns: [
                        {
                            // Account + its own side of the entry. One pill,
                            // dynamically labeled Debit/Credit — whichever of
                            // debitAmount/creditAmount is actually set.
                            weight: 4,
                            basis: '40%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'accountIdName',
                                    scale: 'title'
                                },
                                {
                                    type: 'dualPill',
                                    debitField: 'debitAmount',
                                    creditField: 'creditAmount',
                                    scale: 'title',
                                    debitLabel: 'journal.form.line.debit',
                                    creditLabel: 'journal.form.line.credit',
                                    decorator: 'transactionCurrency',
                                    variant: 'info'
                                }
                            ]
                        },
                        {
                            // Under the description: what the line was picked as,
                            // who it is against, and the document it names.
                            weight: 3,
                            basis: '30%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'normal'
                                },
                                {
                                    type: 'field',
                                    value: 'typeName',
                                    scale: 'normal'
                                },
                                {
                                    type: 'field',
                                    value: 'typeRefIdName',
                                    scale: 'normal',
                                    condition: { field: 'typeRefId', operator: 'notEmpty' }
                                },
                                {
                                    type: 'field',
                                    value: 'documentNumber',
                                    scale: 'normal',
                                    condition: { field: 'documentId', operator: 'notEmpty' }
                                }
                            ]
                        },
                        {
                            // Counter account, only for a self-balancing smart
                            // line. It takes the mirrored opposite side of the
                            // same gross amount, hence debitField/creditField
                            // swapped relative to the account's own pill above.
                            weight: 4,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'counterAccountIdName',
                                    scale: 'title',
                                    condition: { field: 'counterAccountId', operator: 'notEmpty' }
                                },
                                {
                                    type: 'dualPill',
                                    debitField: 'creditAmount',
                                    creditField: 'debitAmount',
                                    scale: 'title',
                                    debitLabel: 'journal.form.line.debit',
                                    creditLabel: 'journal.form.line.credit',
                                    decorator: 'transactionCurrency',
                                    variant: 'info',
                                    condition: { field: 'counterAccountId', operator: 'notEmpty' }
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },
    postingRuleCard: {
        entity: 'postingRule',
        path: 'postingRule',
        titleBar: { mergeParams: ['name'], new: 'postingRule.form.new.title' },
        cardTitle: {
            title: 'postingRule.form.dropdown.toggle',
            buttons: [
                {
                    type: 'submit',
                    id: 'postingRuleCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'postingRuleConfirmDelete'
                }
            ]
        },
        width: '700px',
        sections: [
            {
                id: 'postingRule',
                meta: {
                    type: 'form',
                    width: '700px'
                },
                groups: [
                    {
                        type: 'text',
                        id: 'name',
                        label: 'postingRule.form.name',
                        placeholder: 'postingRule.form.name.placeholder',
                        required: true
                    },
                    {
                        type: 'group',
                        id: 'typeBookId',
                        fields: [
                            {
                                type: 'select',
                                id: 'type',
                                displayField: 'typeName',
                                label: 'postingRule.form.type',
                                entity: 'journalEntryType',
                                valueMap: {
                                    'type': 'id',
                                    'typeName': 'name'
                                },
                                options: { withHeaders: false },
                                required: true
                            },
                            {
                                type: 'select',
                                id: 'bookId',
                                displayField: 'bookIdName',
                                label: 'postingRule.form.book',
                                entity: 'accountingBookType',
                                valueMap: {
                                    'bookId': 'id',
                                    'bookIdName': 'name'
                                },
                                options: { withHeaders: false },
                                required: true,
                                defaultType: 'value',
                                defaultValue: 'BASE'
                            }
                        ]
                    },
                    {
                        type: 'number',
                        id: 'priority',
                        label: 'postingRule.form.priority',
                        placeholder: 'postingRule.form.priority.placeholder',
                        required: true,
                        defaultType: 'value',
                        defaultValue: 100
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'postingRuleCard.header.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'typeName',
                    emptyMessage: 'postingRule.form.type.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} · ${2} · priority ${3}',
                                    mergeParams: ['typeName', 'bookIdName', 'priority'],
                                    scale: 'normal'
                                },
                                /*
                                 * The whole condition in one line, so the header
                                 * says what the rule selects without expanding the
                                 * conditions below. matchText is derived on save.
                                 * No condition means the rule catches every code of
                                 * its type, and says so rather than showing nothing.
                                 */
                                {
                                    type: 'field',
                                    value: 'matchText',
                                    prefix: 'postingRule.display.appliesWhen',
                                    scale: 'normal',
                                    condition: { field: 'matchText', operator: 'notEmpty' }
                                },
                                {
                                    type: 'text',
                                    value: 'postingRule.display.appliesToAll',
                                    scale: 'normal',
                                    condition: { field: 'matchText', operator: 'empty' }
                                }
                            ]
                        }
                    ]
                }
            },
            /*
             * "Applies when" — the condition, as rows a form can edit. Every row
             * must hold. The postingRule calculation chain builds the `match` the
             * engine evaluates from these rows on every save, so what is shown
             * here is what posting uses. No rows: the rule applies to every tax
             * code of its type, and a lower priority number wins over it.
             *
             * The field picker also sets `valueType`, which types the value when
             * `match` is built — selfAccounted compares as a boolean, an official
             * code such as ES "09" stays text.
             */
            {
                id: 'postingRule.conditions',
                meta: {
                    type: 'lines',
                    linesArray: 'conditions',
                    linesAddAction: 'postingRule.form.condition.add',
                    sectionTitle: 'postingRule.form.conditions.title',
                    width: '700px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'fieldOperator',
                        fields: [
                            {
                                type: 'select',
                                id: 'field',
                                displayField: 'fieldName',
                                label: 'postingRule.form.condition.field',
                                entity: 'postingRuleMatchField',
                                /*
                                 * `clearValue` is on no attribute entry, so it
                                 * always resolves to null and nullDefaults writes
                                 * '' — picking another attribute clears the value
                                 * that belonged to the previous one, instead of
                                 * leaving "Location is Goods".
                                 */
                                valueMap: {
                                    'field': 'id',
                                    'fieldName': 'name',
                                    'valueType': 'valueType',
                                    'value': 'clearValue',
                                    'valueName': 'clearValue'
                                },
                                nullDefaults: { value: '', valueName: '' },
                                options: { withHeaders: false },
                                required: true,
                                weight: 1
                            },
                            {
                                type: 'select',
                                id: 'operator',
                                displayField: 'operatorName',
                                label: 'postingRule.form.condition.operator',
                                entity: 'postingRuleMatchOperator',
                                valueMap: {
                                    'operator': 'id',
                                    'operatorName': 'name'
                                },
                                options: { withHeaders: false },
                                required: true,
                                defaultType: 'value',
                                defaultValue: 'equals',
                                weight: 1
                            }
                        ]
                    },
                    /*
                     * Picked, never typed: only the values the chosen attribute
                     * can take, so a condition can only name something a tax code
                     * actually carries. The list is filtered server-side by
                     * ?field=<attribute>, and refetches when the attribute changes.
                     * autoSelectFirst is off — a value the person did not choose
                     * would route VAT they never meant to route.
                     */
                    {
                        type: 'select',
                        id: 'value',
                        displayField: 'valueName',
                        label: 'postingRule.form.condition.value',
                        placeholder: 'postingRule.form.condition.value.placeholder',
                        entity: 'postingRuleMatchValue',
                        entityParams: { type: 'query', params: [{ key: 'field', value: '${field}' }] },
                        valueMap: {
                            'value': 'value',
                            'valueName': 'name'
                        },
                        options: { withHeaders: false, autoSelectFirst: false },
                        required: true,
                        lineLinkedFields: ['field']
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'postingRuleCard.conditions.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'postingRuleCard.conditions.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'field',
                    emptyMessage: 'postingRule.form.condition.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} ${2} ${3}',
                                    mergeParams: ['fieldName', 'operatorName', 'valueName'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'postingRule.legs',
                meta: {
                    type: 'lines',
                    linesArray: 'legs',
                    linesAddAction: 'postingRule.form.leg.add',
                    width: '700px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'roleAccount',
                        fields: [
                            {
                                type: 'select',
                                id: 'role',
                                displayField: 'roleName',
                                label: 'postingRule.form.leg.role',
                                entity: 'postingRuleRole',
                                valueMap: {
                                    'role': 'id',
                                    'roleName': 'name'
                                },
                                options: { withHeaders: false },
                                required: true,
                                weight: 1
                            },
                            {
                                type: 'connect',
                                id: 'accountId',
                                displayField: 'accountIdName',
                                label: 'postingRule.form.leg.account',
                                placeholder: 'postingRule.form.leg.account.placeholder',
                                modalTitle: 'postingRule.form.leg.account.modal.title',
                                entity: 'glAccount',
                                valueMap: {
                                    'accountId': 'id',
                                    'accountIdName': 'name',
                                    // For the rule's legsText summary ("7740 Debit").
                                    'accountNumber': 'number'
                                },
                                options: {
                                    withHeaders: false,
                                    highlight: { condition: { field: 'accountType', operator: 'in', value: ['header', 'sum'] } },
                                    selectable: { condition: { field: 'isPostable', operator: 'notEquals', value: false } }
                                },
                                listDisplay: { text: '${1} - ${2}', params: ['name', 'number'] },
                                required: true,
                                weight: 2
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'signAmountFrom',
                        fields: [
                            {
                                type: 'select',
                                id: 'sign',
                                displayField: 'signName',
                                label: 'postingRule.form.leg.sign',
                                entity: 'glNormalBalance',
                                valueMap: {
                                    'sign': 'id',
                                    'signName': 'name'
                                },
                                options: { withHeaders: false },
                                required: true,
                                weight: 1
                            },
                            {
                                type: 'select',
                                id: 'amountFrom',
                                displayField: 'amountFromName',
                                label: 'postingRule.form.leg.amountFrom',
                                entity: 'postingRuleAmountFrom',
                                valueMap: {
                                    'amountFrom': 'id',
                                    'amountFromName': 'name'
                                },
                                options: { withHeaders: false },
                                required: true,
                                weight: 1
                            }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'postingRuleCard.legs.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'postingRuleCard.legs.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'role',
                    emptyMessage: 'postingRule.form.leg.role.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '50%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'roleName',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'accountIdName',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 1,
                            basis: '50%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'signName',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'amountFromName',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    }
}
